<template>
    <div>
        <div class="position-fixed w-100"
             style="height: 100px;background: #8a00e5;">
            <AndonHeader ref="andonHeader"
                         :operatorStatus="userStatus"
                         :station="ppOperation.actualMstLocationName"
                         :value="lightValue"
                         :workCenter="ppOperation.forecastMstLocationName"
                         @needFresh="getStationUserList"
                         @switchMstLocation="handleSwitchMstLocation"
            ></AndonHeader>
        </div>
        <div class="position-fixed w-100 pt-2 pb-2 h-auto" style="top: 100px;bottom: 114px;overflow-y:scroll;">
            <div v-show="!showAndonManagement">
                <div class="col w-auto p-2 prd-seq-excute">
                    <div class="row">
                        <KeyValueCell :value="ppOperation.projectCode" class="col" click-able
                                      @valueClick="projectInfoPageVisible=true">项目号
                        </KeyValueCell>
                        <KeyValueCell :value="ppOperation.projectName" class="col">项目名称</KeyValueCell>
                        <KeyValueCell
                            :router-link="'/sithMes/prd/sithMesPrdPpOperationList?orderCode='+ppOperation.orderCode"
                            :value="ppHeader.orderCode"
                            class="col">
                            工单编号
                        </KeyValueCell>
                        <KeyValueCell :value="ppHeader.forecastBeginTime" class="col">计划开始时间</KeyValueCell>
                        <KeyValueCell :value="ppHeader.forecastFinishTime" class="col">计划结束时间</KeyValueCell>
                    </div>
                    <div class="row">
                        <KeyValueCell :value="ppHeader.orderType" class="col">工单类型</KeyValueCell>
                        <KeyValueCell :value="String(ppHeader.orderQuantity)" class="col">加工数量</KeyValueCell>
                        <KeyValueCell :value="ppHeader.materialCode" class="col">物料编码</KeyValueCell>
                        <KeyValueCell
                            :router-link="'/sithMes/prd/sithMesPrdPpComponentList?orderNumber='+ppOperation.orderCode"
                            :value="ppHeader.materialDescription"
                            class="col">
                            物料描述
                        </KeyValueCell>
                        <KeyValueCell :value="ppHeader.actualStartTime" class="col">实际开始时间</KeyValueCell>
                    </div>
                </div>

                <el-divider></el-divider>

                <div class="row prd-seq-excute">
                    <div class="col-6">
                        <!-- 工序物料信息，暂时为空，待处理-->
                        <el-table :data="componentTable" max-height="400" style="width: 100%" @cell-click="showDetail">
                            <el-table-column label="工序物料信息">
                                <el-table-column
                                    label="ITEM"
                                    prop="item"
                                ></el-table-column>
                                <el-table-column
                                    label="物料代码"
                                    prop="material"
                                ></el-table-column>
                                <el-table-column
                                    label="物料描述"
                                    prop="desc"
                                ></el-table-column>
                                <el-table-column
                                    label="数量"
                                    prop="quantity"
                                ></el-table-column>
                                <el-table-column
                                    label="单位"
                                    prop="unit"
                                ></el-table-column>
                                <el-table-column
                                    label="发货状态"
                                    prop="deliverStatus"
                                ></el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="col-6 d-flex flex-column">
                        <KeyValueCell :value="ppOperation.operationSeq" horizontal>工序编号</KeyValueCell>
                        <div class="d-flex flex-row">
                            <KeyValueCell :value="ppOperation.workHour" horizontal>排产工时(H)</KeyValueCell>
                            <KeyValueCell :value="ppOperation.usedWorkHour" class="ml-2" horizontal>使用工时(H)
                            </KeyValueCell>
                        </div>
                        <div class="d-flex flex-row">
                            <KeyValueCell :value="ppOperation.bufferHour" horizontal>缓冲时间(H)</KeyValueCell>
                            <KeyValueCell :value="ppOperation.transferHour" class="ml-2" horizontal>周转时间(H)
                            </KeyValueCell>
                        </div>
                        <div class="d-flex flex-row">
                            <KeyValueCell :value="ppOperation.manHour" horizontal>
                                人工计划工时({{ hasCode(ppOperation.manHourUnit) ? ppOperation.manHourUnit : 'H' }})
                            </KeyValueCell>
                            <KeyValueCell :value="ppOperation.machineHour" class="ml-2" horizontal>
                                机器计划工时({{
                                    hasCode(ppOperation.machineHourUnit) ? ppOperation.machineHourUnit : 'H'
                                }})
                            </KeyValueCell>
                        </div>
                        <KeyValueCell :value="ppOperation.forecastBeginTime" horizontal>计划开始时间</KeyValueCell>
                        <KeyValueCell :value="ppOperation.actualBeginTime" horizontal>实际开始时间</KeyValueCell>
                        <KeyValueCell :value="ppOperation.forecastFinishTime" horizontal>预期结束时间</KeyValueCell>
                        <KeyValueCell :value="operationDescriptionText" pre-line>工序描述</KeyValueCell>
                    </div>
                </div>
            </div>

            <AndonManagement
                v-if="lazyLoad"
                v-show="showAndonManagement"
                :locationId="ppOperation.actualMstLocationId"
                :ppOperation="ppOperation.id"
                v-on:lightValueChanged="setLightValue"
            ></AndonManagement>
        </div>
        <div
            class="row position-fixed w-100 m-0"
            style="height: 114px;left: 0;bottom: 0;">
            <PpExecuteButton
                :to_large_icon="showAndonManagement"
                awesome_icon="lightbulb"
                class="el-menu-item-first"
                @clickIcon="andonManagement">
                安 灯 管 理
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="tasks"
                class="el-menu-item-second"
                @clickIcon="router.push('/sithMes/andon/sithMesAndonTaskList?mstLocationName=' + ppOperation.actualMstLocationName)">
                安 灯 进 度
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="id-card"
                class="el-menu-item-third"
                @clickIcon="switchOperatorStatus(3)">
                人 员 状 态
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="play-circle"
                class="el-menu-item-second"
                @clickIcon="switchOperatorStatus(1)">
                上 工
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="power-off"
                class="el-menu-item-third"
                @clickIcon="switchOperatorStatus(2)">
                下 工
            </PpExecuteButton>
            <PpExecuteButton
                :to_large_icon="hasShiftContentViewed"
                awesome_icon="people-carry"
                class="el-menu-item-first"
                @clickIcon="hasShiftContentViewed ? shiftContentListDialog = true : shiftHandOverDialog = true">
                交 接 班
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="check-circle"
                class="el-menu-item-second"
                @clickIcon="checkFreeToStorage">
                确 认 完 工
            </PpExecuteButton>
            <PpExecuteButton
                :to_large_icon="hasInspectTask"
                awesome_icon="file-signature"
                class="el-menu-item-third"
                @clickIcon="openNewInspectTaskModal">
                报 检
            </PpExecuteButton>
            <PpExecuteButton
                awesome_icon="scroll"
                class="el-menu-item-first"
                @clickIcon="paperView">
                图 纸 查 看
            </PpExecuteButton>
        </div>

        <!--工位选择弹窗 -->
        <el-dialog
            :append-to-body="true"
            :visible.sync="stationDialog"
            class="position-relative"
            title="选择工位"
            width="50%">
            <el-form>
                <el-form-item style="text-align:center;">
                    <el-select
                        v-model="station"
                        placeholder="请选择工位"
                        value-key="id"
                    >
                        <el-option
                            v-for="item in currentStationList"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="handleStationDialogClose">取 消</el-button>
          <el-button type="primary" @click="setStation">
            提 交
          </el-button>
        </span>
        </el-dialog>
        <!--人脸扫描上下工弹窗 -->
        <el-dialog
            :append-to-body="true"
            :title="dialogTitle"
            :visible.sync="operatorStatusDialog"
            class="position-relative"
            width="50%"
            :close-on-click-modal='false'
            @closed="close"
            @opened="openCamera">
            <el-form>
                <el-form-item style="text-align:center;">
                    <el-select
                        v-if="selectShow && (!usingFace || cameraOpened)"
                        v-model="workForm.prdStopWorkTypeId"
                        placeholder="请选择休息类型">
                        <el-option
                            v-for="item in stopWorkTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="false" v-model="faceUserId"></el-form-item>
                <div>
                    <Login ref="login"
                           :initialMethodIsPassword="false"
                           @usingFace="handleUsingFace"
                           @user-identified="getFaceUser"
                           identify-for='toWork'
                           @camera-opened="handleCameraOpened"
                    ></Login>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="operatorStatusDialog = false" v-show="cameraOpened">取 消</el-button>
          <el-button type="primary" @click="saveWorkRecord(operatorStatus)"
                     :loading="(!faceIdentify&&cameraOpened) || workHourLoading"
                     v-show="!usingFace || cameraOpened">
            提 交
          </el-button>
        </span>
        </el-dialog>
        <!--    交接班弹窗-->
        <el-dialog
            :append-to-body="true"
            :visible.sync="shiftHandOverDialog"
            title="交接班日志"
            width="50%">
            <el-form>
                <el-form-item :label-width="formLabelWidth" label="班次">
                    <el-select
                        v-model="handOverForm.mstShiftTeamFromId"
                        placeholder="请选择班次"
                        value-key="id">
                        <el-option
                            v-for="item in shiftList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth" label="内容简述">
                    <el-input
                        v-model="handOverForm.shiftContent"
                        :autosize="{ minRows: 3, maxRows: 10 }"
                        placeholder="请输入内容"
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button
              @click="()=>{ this.shiftHandOverDialog = false; this.shiftContentListDialog = true }">查看记录</el-button>
          <el-button @click="shiftHandOverDialog = false">取 消</el-button>
          <el-button type="primary" @click="saveShiftHandOver">
            提 交
          </el-button>
        </span>
        </el-dialog>
        <!--交接班日志弹窗-->
        <el-dialog
            :append-to-body="true"
            :visible.sync="shiftContentListDialog"
            title="交接班记录"
            width="80%"
            @open="hasShiftContentViewed = false">
            <div class="row w-100 font-weight-bold" style="background-color: #ebebeb">
                <div class="col-2">交接班时间</div>
                <div class="col-2">交班班组</div>
                <div class="col-2">提交人</div>
                <div class="col-6">交接班内容</div>
            </div>
            <div class="w-100 mt-1">
                <div v-if="shiftContentList.length === 0" class="row w-100">
                    <p class="m-auto text-center font-weight-bold" style="font-size: 1.5rem">无记录</p>
                </div>
                <div v-for="(row,index) in shiftContentList" :key="index" class="row w-100">
                    <div class="col-2">
                        {{ row.startDate }}
                    </div>
                    <div class="col-2">
                        {{ row.mstShiftTeamFromName }}
                    </div>
                    <div class="col-2">
                        {{ row.createdByUserName }}
                    </div>
                    <div class="col-6">
                        {{ row.shiftContent }}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
          <el-button
              @click="()=>{ this.shiftHandOverDialog = true; this.shiftContentListDialog = false }">新 增</el-button>
          <el-button type="primary" @click="shiftContentListDialog = false">确 定</el-button>
        </span>
        </el-dialog>
        <!--确认完工弹窗-->
        <el-dialog
            :append-to-body="true"
            :visible.sync="operationComplete"
            title="确认完工"
            width="50%">
            <el-form v-if="!isLastFinish || defaultVirtualEntry">
                <span class="dialog_span">确认结束本工序？</span>
                <div v-if="defaultVirtualEntry" class="alert alert-info mt-3 mb-0 py-2">
                    <i class="fa fa-fw fa-info-circle"></i>
                    本工序为工单最后一序，当前工位已配置「完工默认虚入」，提交后将自动按<strong>虚入</strong>申请入库并回写 SAP 101 收货，无需选择入库类型。
                </div>
            </el-form>
            <div v-else class="d-flex flex-column">
                <DiverseInput :config="finishInputTypeConfig" :value.sync="finishInputType"></DiverseInput>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="operationCompleteDialogClose">取 消</el-button>
                <b-overlay :show="submitting" spinner-small
                           spinner-type="grow" spinner-variant="primary">
                    <el-button type="primary" @click="applyForWarehousing">提 交</el-button>
                </b-overlay>
            </span>
        </el-dialog>
        <!--报检内容填写弹窗-->
        <ReBModal ref="inspectTaskModal"
                  header="发起检验任务"
                  @hide="inspectTaskInfo=''"
                  @ok="submitProcessQualityInspectTask">
            <DiverseInput :config="inspectTaskInfoConfig" :value.sync="inspectTaskInfo"></DiverseInput>
        </ReBModal>
        <!--图纸查看弹窗-->
        <pdf-drawings-view ref="pdfDrawingView" :material="ppHeader.materialCode"
                           :attachment-ids="ppHeader.attachments + ',' + ppOperation.attachments"></pdf-drawings-view>

        <prd-project-info-page v-if="projectInfoPageVisible" :project-code="ppOperation.projectCode"
                               :work-station="ppOperation.actualMstLocationName"
                               @cancel="projectInfoPageVisible=false"></prd-project-info-page>
    </div>
</template>
<script>
// Author Eric
// Date 2020-09-19 12:46:59

import AndonHeader from "./AndonHeader";
import AndonManagement from "./AndonManagement";
import screenfull from "screenfull";
import emCommonApi from "@/mixin/em/common/api";
import {getDate, getTimeOfDay} from "../../../../components/wx/TimeUtil";
import PpExecuteButton from "./cells/PpExecuteButton";
import KeyValueCell from "./cells/KeyValueCell";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import PrdProjectInfoPage from "@/views/sithMes/prd/PrdOperationExcute/PrdProjectInfoPage.vue";
import Login from "@/components/em/login/Login";
import PdfDrawingsView from "@/views/sithMes/prd/PrdOperationExcute/stuffs/PdfDrawingsView.vue";
import {formatOperationDescription} from "@/utils/operationDescriptionFormatter";


export default {
    name: "prdSeqExcute",
    mixins: [emCommonApi],
    components: {
        PdfDrawingsView,
        Login,
        PrdProjectInfoPage,
        DiverseInput,
        ReBModal,
        KeyValueCell,
        PpExecuteButton,
        AndonHeader,
        AndonManagement
    },
    data: function () {
        return {
            lightValue: 1,
            userStatus: 0,
            locationType: "0",
            station: {id: null, name: null},
            showAndonManagement: false, // 是否显示安灯界面
            operatorStatusDialog: false, // 是否打开人员切换弹窗
            operatorStatus: 0,
            dialogTitle: "", //弹窗页标题
            shiftHandOverDialog: false, //交接班弹窗
            stationDialog: false, //工位选择弹窗
            operationComplete: false,
            selectShow: false, //弹窗页是否展示下拉框
            formLabelWidth: "100px",
            faceUserId: "", //扫脸用户id
            ppHeader: {},
            ppOperation: {},
            router: this.$router,
            stopWorkTypeList: null,
            stationList: null,
            usedForSwitchMstLocation: false,
            stationListFromTag: null,
            workForm: {
                id: null,
                userId: null,
                prdPpOperationId: null,
                startTime: null,
                endTime: null,
                prdStopWorkTypeId: null,
                actualMstLocationId: null,
                beforeUpdateMstLocationId: null
            },
            handOverForm: {
                id: null,
                prdPpOperationId: null,
                mstShiftTeamFromId: 101, //暂时只有一班二班两种数据
                actualMstLocationId: null,
                shiftContent: null
            },
            shiftList: [
                {id: 101, name: "一班"},
                {id: 102, name: "二班"},
                {id: 103, name: "三班"}
            ],
            lazyLoad: false,
            faceIdentify: false,
            hasShiftContentViewed: false,
            shiftContentList: [],
            shiftContentListDialog: false,
            hasInspectTask: false,
            inspectTaskInfo: '',
            inspectTaskInfoConfig: {
                label: '检验任务描述',
                type: 'input',
            },
            subscribeItem: {
                id: 'inspectTaskFinish',
                topic: 'inspectTask/finish',
                callback: () => {
                    this.checkInspectTaskExistence();
                }
            },

            isLastFinish: false,
            finishInputType: -1,
            finishInputTypeConfig: {
                label: '入库类型',
                type: 'select',
                options: [
                    {value: 0, text: '虚入'},
                    {value: 1, text: '实入'},
                ]
            },
            defaultVirtualEntry: false,
            workHourLoading: false,
            componentTable: [],

            projectInfoPageVisible: false,//项目信息全屏展示页

            cameraOpened: false,
            usingFace: true,
            submitting: false,
        };
    },
    beforeCreate() {
        if (!screenfull.isFullscreen) {
            screenfull.on("change", () => {
            });
            screenfull.toggle();
        }
    },
    created() {
        this.setVisibile();
        this.getHeaderInfo();
        // this.getOperationInfo();
        this.getStopWorkTypeList();

        this.getComponentTableData();
    },
    mounted() {
        this.$webSocket.subscribeToPoint(this.subscribeItem);
    },
    beforeDestroy() {
        this.$webSocket.unsubscribeToPoint(this.subscribeItem.id);
    },
    methods: {
        getComponentTableData() {
            this.componentTable = [];

            if (!this.ppOperation.id) {
                return;
            }
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesPrdPpComponent")}/sithMesPrdPpComponent/findComponentByOperation/` + this.ppOperation.id;
            this.$_emApiMixin_post(_api, {}).then(data => {
                if (data.data.length > 0) {
                    let tempList = [];
                    for (let item of data.data) {
                        this.componentTable.push({
                            material: item.material,
                            quantity: item.quantity,
                            desc: item.desc,
                            deliverStatus: item.deliverStatus,
                            unit: item.unit,
                            item: item.item
                        })
                    }
                }
            })

        },
        showDetail(row, column, cell, event) {
            if (column.property === 'quantity') {
                this.$router.push({
                    name: "sithMesPrdPpComponentList",
                    query: {'operationId': this.ppOperation.id, 'material': row.material},
                });
            } else if (column.property === 'material') {
                this.$router.push({
                    name: "sithMesPrdPpHeaderList",
                    query: {'material': row.material},
                });
            }
        },
        getRemoteData_shiftContent() {
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesPrdShiftHandover")}/sithMesPrdShiftHandover/findByFilter`
            this.$_emApiMixin_post(_api, {
                prdPpOperationIdFilter: this.ppOperation.id,
                mstLocationIdFilter: this.ppOperation.actualMstLocationId
            }).then(data => {
                if (data.data.list.length > 0) {
                    let tempList = [];
                    for (let item of data.data.list) {
                        tempList.push({
                            startDate: getDate(item.beginDatetime),
                            startTime: getTimeOfDay(item.beginDatetime),
                            mstShiftTeamFromName: item.mstShiftTeamFromName,
                            createdByUserName: item.createdByUserName,
                            shiftContent: item.shiftContent
                        })
                    }
                    this.shiftContentList = tempList;
                    this.hasShiftContentViewed = true;
                }
            })
        },
        getStation() {
            //查询计划工作中心下的工位
            let _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesMstLocation/findByFilter";
            this.$_emApiMixin_post(_api, {
                // parentIdFilter: 1798
                parentIdFilter: this.ppOperation.forecastMstLocationId
            }).then(data => {
                this.stationList = data.data.list;
                this.checkStation();
            });
        },
        checkStation() {
            if (this.stationList == null || this.stationList.length === 0) {
                return true;
            }
            //如果当前location已经是工位 则不再更新选择
            for (let location of this.stationList) {
                if (location.id === this.ppOperation.actualMstLocationId) {
                    return true;
                }
            }
            //如果当前location已经是工厂建模标签配置code对应的工位的工位，则不再更新选择
            let target = this.stationListFromTag.find(mstLocation => mstLocation.id === this.ppOperation.actualMstLocationId);
            if (target) {
                return true;
            }
            //非man类型实际工作中心指定为计划工作中心
            if (this.ppOperation.forecastMstLocationType === "machine-工作中心") {
                this.station = this.stationList[0];
                this.setStation();
            } else {
                //man类型工作中心才会选择工位
                this.$message({
                    message: "请选择一个工位",
                    type: "warning"
                });
                this.stationDialog = true;
                this.operatorStatusDialog = false;
            }
        },
        setStation() {
            if (this.station.id != null) {
                const _api =
                    this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                    "/sithMesPrdPpOperation/selective";
                this.$_emApiMixin_put(_api, {
                    id: this.ppOperation.id,
                    actualMstLocationId: this.station.id,
                    forecastMstLocationId: this.station.parentId,
                    isLocked: false
                }).then(() => {
                    this.beforeUpdateMstLocationId = this.ppOperation.actualMstLocationId
                    this.ppOperation.actualMstLocationId = this.station.id;
                    this.ppOperation.actualMstLocationName = this.station.name;
                    this.ppOperation.forecastMstLocationId = this.station.parentId;
                    this.ppOperation.forecastMstLocationName = this.station.parentName
                });
            }
            this.stationDialog = false;
            this.usedForSwitchMstLocation = false
        },
        handleStationDialogClose() {
            this.stationDialog = false;
            this.usedForSwitchMstLocation = false
        },
        setLightValue(lightValue) {
            this.lightValue = lightValue;
        },
        setVisibile() {
            this.ppHeader.id = this.$route.query.header;
            this.ppOperation.id = this.$route.query.operation;
            this.$store.commit("base/setShowHeader", false, {root: true});
            this.$store.commit("base/setShowSidebar", false, {root: true});
        },
        initPageInfo() {
            if (null == this.ppOperation.actualMstLocationId) {
                this.ppOperation.actualMstLocationId = 0;
            }

            this.workForm.actualMstLocationId = this.ppOperation.actualMstLocationId;
            this.workForm.prdPpOperationId = this.ppOperation.id;
            this.handOverForm.actualMstLocationId = this.ppOperation.actualMstLocationId;
            this.handOverForm.prdPpOperationId = this.ppOperation.id;
        },
        checkAndonInfoComplete() {
            return (
                this.ppHeader.id !== null &&
                this.ppOperation.id !== null &&
                this.ppOperation.actualMstLocationId !== null
            );
        },
        andonManagement() {
            if (this.checkAndonInfoComplete()) {
                if (this.checkStation() === true) {
                    this.lazyLoad = true;
                    this.showAndonManagement = !this.showAndonManagement;
                }
            } else {
                this.$message({
                    message: "操作过快，请稍后重试！",
                    type: "warning"
                });
            }
        },
        switchOperatorStatus(index) {
            this.operatorStatus = index;
            if (1 === index) {
                this.dialogTitle = "上工";
            }
            if (2 === index) {
                this.dialogTitle = "下工";
            }
            if (3 === index) {
                this.dialogTitle = "间歇";
                this.operatorStatus = 0;
                this.selectShow = true;
            }
            this.$interaction({
                identifyCode: 'operation-execute',
                actionName: 'btn-click',
                actionContent: this.dialogTitle
            });
            this.operatorStatusDialog = true;
            this.checkStation();
        },
        clearOperatorStatus() {
            this.operatorStatus = 0;
            this.selectShow = false;
        },
        openCamera() {
            this.$refs.login.openFromOutside();
        },
        close() {
            if (this.cameraOpened) {
                this.faceIdentify = false;
                this.cameraOpened = false;
            }
            if (this.$refs.login) {
                this.$refs.login.resetFaceLoginInfo()
                this.$refs.login.resetPasswordLoginInfo()
            }
            this.clearOperatorStatus();
        },
        getFaceUser(userId) {
            if (this.cameraOpened) {
                this.faceUserId = userId;
                this.faceIdentify = true;
            }
            this.workForm.userId = userId;
        },
        handleUsingFace(usingFace) {
            this.usingFace = usingFace
        },
        handleCameraOpened(CameraOpened) {
            this.cameraOpened = CameraOpened
        },
        getHeaderInfo() {
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdPpHeader/findByFilter";
            this.$_emApiMixin_post(_api, {
                idFilter: this.ppHeader.id
            }).then(data => {
                this.ppHeader = data.data.list[0];
                this.getOperationInfo();
            });
        },

        getOperationInfo() {
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdPpOperation/findByFilter";
            this.$_emApiMixin_post(_api, {
                idFilter: this.ppOperation.id
            }).then(data => {
                this.ppOperation = data.data.list[0];
                this.initPageInfo();
                this.getStationUserList();
                this.getStation();
                this.getStationListFromTag();
                if (this.checkAndonInfoComplete()) {
                    this.lazyLoad = true;
                }
                this.getRemoteData_shiftContent()
                this.checkInspectTaskExistence()
            });
        },
        operationCompleteDialogClose() {
            this.operationComplete = false;
            this.finishInputType = -1;
            this.isLastFinish = false;
            this.defaultVirtualEntry = false;
        },
        completeOperation() {
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdPpOperation/selective";
            this.$_emApiMixin_put(_api, {
                id: this.ppOperation.id,
                prdPpStatusCode: 6
            }).then(() => {
                this.$message({
                    message: "操作成功！",
                    type: "success"
                });
            });
            this.operationCompleteDialogClose();
        },
        getStopWorkTypeList() {
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdStopWorkType/findByFilter";
            this.$_emApiMixin_post(_api, {
                parentIdFilter: 7027 //间歇类型的根节点
            }).then(data => {
                this.stopWorkTypeList = data.data.list;
            });
        },
        // 根据工厂建模标签的配置，查询可替换的工位
        getStationListFromTag() {
            const actualMstLocationId = this.ppOperation.actualMstLocationId;
            if (actualMstLocationId) {
                const _api =
                    this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                    "/sithMesMstLocationTagLoct/findReplaceableMstLocations?locationId=" + actualMstLocationId;
                this.$_emApiMixin_get(_api).then(response => {
                    this.stationListFromTag = response
                });
            }
        },
        //recordType为1表示上工，2表示下工，3表示间歇
        async saveWorkRecord(recordType) {
            this.$interaction({
                identifyCode: 'operation-execute',
                actionName: 'btn-click',
                actionContent: '提交上下工,Type:' + recordType
            });
            if (!this.cameraOpened) {
                const userId = await this.$refs.login.getUserByPassword();
                if (!userId) {
                    return;
                }
                this.workForm.userId = userId
            }
            if (this.workHourLoading) {
                return;//?避免重复操作?
            }
            this.workHourLoading = true;
            if (this.workForm.prdStopWorkTypeId == null) {
            }
            this.workForm.actualMstLocationId = this.ppOperation.actualMstLocationId;
            this.workForm.beforeUpdateMstLocationId = this.beforeUpdateMstLocationId
            let urlType = "";
            if (1 === recordType) {
                this.workForm.prdStopWorkTypeId = null;
                this.workForm.startTime = this.$_emApiMixin_dateFormat(new Date());
                this.workForm.endTime = null;
                urlType = "/goToWork";
            } else {
                if (2 === recordType) {
                    this.workForm.prdStopWorkTypeId = 7026; //正常下工
                } else if (this.workForm.prdStopWorkTypeId == null) {
                    this.$message.warning("请选择下工类型");
                    this.workHourLoading = false;
                    return;
                }
                this.workForm.startTime = null;
                this.workForm.endTime = this.$_emApiMixin_dateFormat(new Date());
                urlType = "/getOffWork";
            }

            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdWorkHourRecord" +
                urlType;
            this.$_emApiMixin_put(_api, this.workForm).then(() => {
                this.getStationUserList();
                this.$message({
                    message: "操作成功",
                    type: "success"
                });
            }).finally(() => {
                this.operatorStatusDialog = false;
                this.workHourLoading = false;
            });
        },
        getStationUserList() {
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdWorkHourRecord/findUserOnBoard";
            this.$_emApiMixin_post(_api, {
                prdPpOperationIdFilter: this.workForm.prdPpOperationId,
            }).then(data => {
                let hasUser = data.data !== "";
                this.$refs['andonHeader'].userList = hasUser ? data.data : "离岗";
                this.userStatus = hasUser ? 1 : 0;
                this.$refs['andonHeader'].loading = false;
            });
        },
        saveShiftHandOver() {
            if (!this.hasCode(this.handOverForm.shiftContent)) {
                this.$message({
                    message: "添加失败，请输入完整信息",
                    type: 'error'
                });
                return
            }
            this.handOverForm.beginDatetime = this.$_emApiMixin_dateFormat(new Date());
            const _api =
                this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                "/sithMesPrdShiftHandover";
            this.$_emApiMixin_put(_api, this.handOverForm).then(() => {
                this.$message({
                    message: "添加成功",
                    type: "success"
                });
                this.getRemoteData_shiftContent()
            });
            this.shiftHandOverDialog = false;
        },
        hasCode(val) {
            return val !== undefined && val !== null && val !== "";
        },
        //打开检验modal
        openNewInspectTaskModal() {
            if (this.ppOperation.bufferHour !== undefined && this.ppOperation.bufferHour != null && this.ppOperation.bufferHour > 0) {
                this.checkInspectTaskExistence(true);
            } else {
                this.$message.warning("该工序不满足报检条件");
            }
        },
        //提交检验任务
        submitProcessQualityInspectTask() {
            let _api = this.$store.state.sithMesQualityInspectTask.baseModuleUrl +
                "/sithMesQualityInspectTask/processTask";
            this.$_emApiMixin_post(_api, {
                inspectObject: this.ppOperation.id,
                remark: this.inspectTaskInfo
            }).then(() => {
                this.$message.success("提交成功");
            });
        },
        //检查是否存在未完成的检验任务
        checkInspectTaskExistence(openModal) {
            if (this.ppOperation.id != null) {
                let api = this.$store.state.sithMesQualityInspectTask.baseModuleUrl +
                    "/sithMesQualityInspectTask/queryFinish/operation?operationId=" + this.ppOperation.id;
                this.$_emApiMixin_get(api).then(value => {
                    this.hasInspectTask = !value;
                    if (openModal) {
                        if (!this.hasInspectTask) {
                            this.$refs.inspectTaskModal.showModal();
                        } else {
                            this.$message.warning("上一检验任务未完成");
                        }
                    }
                });
            }
        },
        //检查是否为最后一个完工的工序，且为需入库工单
        checkFreeToStorage() {
            if (this.ppOperation.id != null) {
                let api = process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/checkFreeToStorage?id=" + this.ppOperation.id;
                this.$_emApiMixin_post(api).then(response => {
                    let data = response.data;
                    console.log(response)
                    if (data) {
                        if (data === 'default_virtual') {
                            this.defaultVirtualEntry = true;
                            this.finishInputType = 0;
                        }
                        this.isLastFinish = true;
                    }
                    // 判定失败时不弹窗: 否则按"非末序"提交, 末序需入库时会被后端以缺少入库类型拒绝
                    this.operationComplete = true;
                });
            }
        },
        //申请入库
        applyForWarehousing() {
            if (this.isLastFinish && this.finishInputType === -1) {
                this.$message.warning("请选择入库类型");
                return;
            }
            // this.operationComplete = false;
            this.submitting = true;
            let api = process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryStorageInput/applyForProductsWarehousing";
            this.$_emApiMixin_post(api, {
                lastOperationId: this.ppOperation.id,
                inputType: this.finishInputType
            }).then(() => {
                this.$message({
                    message: "操作成功！",
                    type: "success"
                });
                this.operationCompleteDialogClose();
            }).catch(() => this.$message.error("申请入库失败，请重试"))
                .finally(() => this.submitting = false);
        },

        //图纸查看
        paperView() {
            if (this.checkAndonInfoComplete()) {
                this.$refs.pdfDrawingView.show();
            }
        },
        handleSwitchMstLocation() {
            // 当前有可替换的工位
            if (this.ppOperation.prdPpStatusCode === 5 || this.userStatus === 1) {
                this.$message.warning("工序的状态为生产中，不允许修改工位");
                return;
            }
            if (this.stationListFromTag && this.stationListFromTag.length > 0) {
                this.usedForSwitchMstLocation = true
                this.stationDialog = true;
            } else {
                this.$message.warning("当前没有可替换的工位，需要在工厂建模标签进行配置");
            }
        }
    },
    computed: {
        currentStationList() {
            return this.usedForSwitchMstLocation ? this.stationListFromTag : this.stationList
        },
        operationDescriptionText() {
            return formatOperationDescription(this.ppOperation.operationDescription)
        }
    },

    // computed: { ...mapFields(["baseModuleUrl"]) },

    beforeRouteLeave(to, from, next) {
        next(this.$store.commit("base/setShowHeader", true, {root: true}));
        next(this.$store.commit("base/setShowSidebar", true, {root: true}));
        screenfull.toggle();
    }
};
</script>

<style scoped>

.el-menu-item-first {
    background: radial-gradient(ellipse, #8a00e5 100%, #8a00e5);
}

.el-menu-item-second {
    background: radial-gradient(ellipse, #a93df2 100%, #8a00e5);
}

.el-menu-item-third {
    background: radial-gradient(ellipse, #bc6df2 100%, #8a00e5);
}

.el-menu-item-forth {
    background: radial-gradient(ellipse, #590095 100%, #8a00e5);
}

.prd-seq-excute {
    background-color: #f5f7fa;
    margin-left: 10px;
    margin-right: 10px;
}

.el-alert__title {
    font-size: 14px !important;
    text-align: center;
    color: #303133;
}

.el-table {
    font-size: 14px !important;
}

.el-button {
    font-size: 20px !important;
}

.el-form-item__label {
    font-size: 14px !important;
}

.dialog_span {
    font-size: 14px !important;
}

.el-divider--horizontal {
    margin: 2px 0 !important;
}

::v-deep .el-dialog {
    width: 23%;
}

::v-deep .el-dialog__header {
    text-align: center;
}

::v-deep .el-button--primary {
    background-color: #265372;
    border-color: #265372;
}

::v-deep .el-dialog__body {
    padding: 0 20px;
}
</style>
